import { CellContext } from '@tanstack/react-table'
import * as React from 'react'
import { ProficiencyDots } from 'src/design-system'
import { UserPersonalSkillsTableRow } from '../data'

export const ProficiencyCell = (
  data: CellContext<UserPersonalSkillsTableRow, number | null>
) => {
  const isInferred = data.row.original.source === 'implied'
  return (
    <ProficiencyDots
      level={data.getValue() ?? 0}
      filledColor={isInferred ? 'orange' : 'green'}
    />
  )
}
